<div
  class="tile-wrapper flex-1 d-flex fd-col ai-stretch"
  [ngSwitch]="tileInstance?.tileType"
  *ngIf="tileInstance?.canView || editMode"
  [class.no-card]="tileInstance?.displayProperties?.noCard"
>
  <!-- Banner -->
  <suvo-bi-banner-tile
    class="flex-1"
    *ngSwitchCase="'banner'"
    [tileInstance]="tileInstance"
  ></suvo-bi-banner-tile>

  <!-- Banner Text -->
  <suvo-bi-banner-text-tile
    class="flex-1"
    *ngSwitchCase="'banner-text'"
    [tileInstance]="tileInstance"
  ></suvo-bi-banner-text-tile>

  <!-- Chart -->
  <suvo-bi-chart-tile
    class="flex-1"
    *ngSwitchCase="'chart'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    [editMode]="editMode"
  ></suvo-bi-chart-tile>

  <!-- Counts -->
  <suvo-bi-stats-tile
    class="flex-1"
    *ngSwitchCase="'stats'"
    [tileInstance]="tileInstance"
  ></suvo-bi-stats-tile>

  <!-- Link Banner -->
  <suvo-bi-link-banner-tile
    class="flex-1"
    *ngSwitchCase="'link-banner'"
    [tileInstance]="tileInstance"
  ></suvo-bi-link-banner-tile>

  <!-- Link Button -->
  <suvo-bi-link-button-tile
    class="flex-1"
    *ngSwitchCase="'link-button'"
    [tileInstance]="tileInstance"
  ></suvo-bi-link-button-tile>

  <!-- Map -->
  <suvo-bi-map-tile
    class="flex-1"
    *ngSwitchCase="'map'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
  ></suvo-bi-map-tile>

  <!-- Visualise Filters -->
  <suvo-bi-filters-tile
    class="flex-1"
    *ngSwitchCase="'filters'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
  ></suvo-bi-filters-tile>

  <!-- Item Lookup -->
  <suvo-bi-item-lookup-tile
    class="flex-1"
    *ngSwitchCase="'item-lookup'"
    [tileInstance]="tileInstance"
  ></suvo-bi-item-lookup-tile>

  <!-- Table -->
  <suvo-bi-table-tile
    class="flex-1"
    *ngSwitchCase="'table'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    [editMode]="editMode"
  ></suvo-bi-table-tile>

  <!-- <suvo-bi-table-tile class="flex-1" *ngSwitchCase="'table'" [tileInstance]="tileInstance" [filtersChannel]="filtersChannel">
  </suvo-bi-table-tile> -->

  <!-- Visualise Filters -->
  <suvo-bi-filters-info-tile
    class="flex-1"
    *ngSwitchCase="'see-filters'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
  ></suvo-bi-filters-info-tile>

  <!-- Export Button -->
  <suvo-bi-export-button-tile
    class="flex-1"
    *ngSwitchCase="'export-button'"
    [tileInstance]="tileInstance"
  ></suvo-bi-export-button-tile>

  <suvo-bi-hero-banner-tile
    class="flex-1"
    *ngSwitchCase="'hero-banner'"
    [tileInstance]="tileInstance"
  ></suvo-bi-hero-banner-tile>

  <suvo-bi-hero-banner-v2-tile
    class="flex-1"
    *ngSwitchCase="'hero-banner-v2'"
    [tileInstance]="tileInstance"
  ></suvo-bi-hero-banner-v2-tile>

  <suvo-bi-hero-banner-v3-tile
    class="flex-1"
    *ngSwitchCase="'hero-banner-v3'"
    [tileInstance]="tileInstance"
  ></suvo-bi-hero-banner-v3-tile>

  <suvi-bi-icon-columns-tile
    class="flex-1"
    *ngSwitchCase="'icon-columns'"
    [tileInstance]="tileInstance"
  ></suvi-bi-icon-columns-tile>

  <suvo-bi-text-columns-tile
    class="flex-1"
    *ngSwitchCase="'text-columns'"
    [tileInstance]="tileInstance"
  ></suvo-bi-text-columns-tile>

  <suvo-bi-presentation-tile
    class="flex-1"
    *ngSwitchCase="'presentation'"
    [tileInstance]="tileInstance"
  ></suvo-bi-presentation-tile>

  <suvo-bi-text-rows-tile
    class="flex-1"
    *ngSwitchCase="'text-rows'"
    [tileInstance]="tileInstance"
  ></suvo-bi-text-rows-tile>

  <suvo-bi-contacts-tile
    class="flex-1"
    *ngSwitchCase="'contacts'"
    [tileInstance]="tileInstance"
  ></suvo-bi-contacts-tile>

  <suvo-free-trial-tile
    class="flex-1"
    *ngSwitchCase="'free-trial'"
    [tileInstance]="tileInstance"
  ></suvo-free-trial-tile>

  <html-proxy-tile *ngSwitchCase="'html-proxy'" [tileInstance]="tileInstance" />

  <user-custom-component-tile
    *ngSwitchCase="'custom-component'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    src="/assets/demo-list-custom-component.mjs"
  />

  <custom-component-tile
    *ngSwitchCase="'demo-count-custom-component'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    src="/assets/demo-count-custom-component.mjs"
  />

  <custom-component-tile
    *ngSwitchCase="'demo-list-custom-component'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    src="/assets/demo-list-custom-component.mjs"
  />

  <custom-component-tile
    *ngSwitchCase="'tender-list-tile'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    src="/assets/tender-list-tile.mjs"
  />

  <custom-component-tile
    *ngSwitchCase="'analytics-heatmap-custom-component'"
    [tileInstance]="tileInstance"
    [filtersChannel]="filtersChannel"
    src="/assets/analytics-heatmap-custom-component.mjs"
  />

  <rich-text-tile *ngSwitchCase="'rich-text'" [tileInstance]="tileInstance" />

  <link-banner-b-tile *ngSwitchCase="'link-banner-b'" [tileInstance]="tileInstance" />

  <!-- New tile definition -->
  <app-tile-creator
    class="flex-1"
    *ngSwitchCase="'new'"
    [tileInstance]="tileInstance"
  ></app-tile-creator>

  <!-- No tile definition -->
  <suvo-bi-invalid-tile
    class="flex-1"
    *ngSwitchDefault
    [tileInstance]="tileInstance"
  ></suvo-bi-invalid-tile>
</div>

<div
  class="tile-wrapper flex-1 d-flex fd-col ai-stretch"
  *ngIf="!editMode && tileInstance && !tileInstance?.canView"
>
  <!-- No tile definition -->
  <suvo-bi-no-subscription class="flex-1" [tileInstance]="tileInstance"></suvo-bi-no-subscription>
</div>
